import type { FaireProductEntity } from "../../entity_types/product";

export const p_y6p4uady87: FaireProductEntity = {
  token: "p_y6p4uady87",
  type: "product",
  name: "Embroidered California Tote Bag",
  brandToken: "b_c5lwttyyt1",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/268318ffb333d6d5988b66b4b213d315a6d67790569ef4f4e317dca6c52f1aa8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cec14a16baa463e6131ab2b142eb137150abb3e40cc33e370376598953fed960.jpeg",
    "https://cdn.faire.com/fastly/7202ef63ff3339e18188a662f982554d70a3d59e7e51cf05da6f527361d750a8.jpeg",
    "https://cdn.faire.com/fastly/c16f478035f92d285ef3defe9edcaee69a0570036c662a4ce83344d6331a3d22.jpeg",
    "https://cdn.faire.com/fastly/2e19ab0cecbb920eb3c18fc58b6910f6262000dbe39ba4c7313f466bcf1bd09e.jpeg",
    "https://cdn.faire.com/fastly/0887fe73b9f59eac998808e820d51624d6edc72f60c8677aacb4424c890aa08e.jpeg",
    "https://cdn.faire.com/fastly/fb20fbf4d3afea949596c22eac9910c936957c35c812ede2cc22bb67de6afdff.jpeg",
    "https://cdn.faire.com/fastly/da06327125cb1ad274bb338a138617bda01edac9a3142052083cc7b6eb505329.jpeg"
  ],
  priceDollars: 20.79,
  description: "There are lots of California symbols and landmarks on this tote bag. You can touch and feel the texture of the beautiful threads. Each thread color was carefully selected by the artist to capture the California spirit.\n\n• 15”x13”x6”\n• 100% Cotton Canvas\n• 12oz thick very durable fabric\n\nModel in video is 5'3' (160cm) tall\n• Protective inner fabric",
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:56.037Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
